import { render, staticRenderFns } from "./DegreeMap.vue?vue&type=template&id=64c68d76&scoped=true"
import script from "./DegreeMap.vue?vue&type=script&lang=js"
export * from "./DegreeMap.vue?vue&type=script&lang=js"
import style0 from "./DegreeMap.vue?vue&type=style&index=0&id=64c68d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c68d76",
  null
  
)

export default component.exports